module.exports = __webpack_public_path__ + "media/images/flags/ve-38c522dac4ea6d32258ee300b225337b.svg";